<template>
	<div class="mm-page-main">資金管理</div>
</template>

<script>

	export default {
		data() {
			return {
				
			};
		}
		
	};
</script>
